import type { TFunction } from "i18next";
export type ActivePanelTypes = "top" | "bottom";

/** The persisted highlight colors. Data contract — the Redux slice reads
 *  index 0 as its initial state, so this stays free of any label. */
export const PANEL_COLOR_VALUES = [
  "var(--color-success)",
  "var(--color-info)",
  "var(--color-warning)",
  "var(--color-danger)",
  "var(--color-primary)",
] as const;

export const buildColorOptions = (
  t: TFunction,
): { label: string; value: string }[] => [
  {
    label: t("company:expenses.green"),
    value: "var(--color-success)",
  },
  {
    label: t("company:expenses.blue"),
    value: "var(--color-info)",
  },
  {
    label: t("common:chrome.orange"),
    value: "var(--color-warning)",
  },
  {
    label: t("company:expenses.red"),
    value: "var(--color-danger)",
  },
  {
    label: t("company:expenses.purple"),
    value: "var(--color-primary)",
  },
];

export const getHighlightBorderStyles = (highlightColor: string) => {
  const styles = {
    borderLeft: `3px solid ${highlightColor}`,
    borderTop: `3px solid ${highlightColor}`,
    borderRight: `3px solid ${highlightColor}`,
  } as React.CSSProperties;
  return styles;
};
